export var CSS_PREFIX = 'asyncapi';
export var CONTENT_TYPES_SITE = 'https://www.iana.org/assignments/media-types';
export var COLLAPSE_ALL_TEXT = 'Collapse All';
export var EXPAND_ALL_TEXT = 'Expand All';
export var VALIDATION_ERRORS_TYPE = 'https://github.com/asyncapi/parser-js/validation-errors';
export var SERVERS = 'Servers';
export var ONE_OF_PAYLOADS_TEXT = 'One of those payloads:';
export var ANY_OF_PAYLOADS_TEXT = 'Any of those payloads:';
export var GENERATED_BADGE_TEXT = 'generated';
export var ONE_OF_FOLLOWING_MESSAGES_PUBLISH_TEXT = 'You can send one of the following messages:';
export var ONE_OF_FOLLOWING_MESSAGES_PUBLISH_SINGLE_TEXT = 'You can send the following message:';
export var ONE_OF_FOLLOWING_MESSAGES_SUBSCRIBE_TEXT = 'You can subscribe to one of the following messages:';
export var ONE_OF_FOLLOWING_MESSAGES_SUBSCRIBE_SINGLE_TEXT = 'You can subscribe to the following message:';
export var RAW_MESSAGE_SUBSCRIBE_TEXT = 'You can subscribe to the following message:';
export var RAW_MESSAGE_PUBLISH_TEXT = 'You can send the following message:';
export var CONTACT_TEXT = 'Contact';
export var NAM_TEXTE = 'Name';
export var URL_TEXT = 'Url';
export var EMAIL_TEXT = 'Email';
export var LICENSE_TEXT = 'License';
export var TERMS_OF_SERVICE_TEXT = 'Terms of service';
export var URL_SUPPORT_TEXT = 'Support';
export var EMAIL_SUPPORT_TEXT = 'Email support';
export var EXTERAL_DOCUMENTATION_TEXT = 'External Docs';
export var LOCATION_TEXT = 'Location';
export var TYPE_TEXT = 'Type';
export var SPECIFICATION_TEXT = 'Specification';
export var DEPRECATED_TEXT = 'Deprecated';
export var PUBLISH_TEXT = 'Publish';
export var PUBLISH_LABEL_DEFAULT_TEXT = 'PUB';
export var SEND_TEXT = 'Send';
export var SEND_LABEL_DEFAULT_TEXT = 'SEND';
export var SUBSCRIBE_TEXT = 'Subscribe';
export var SUBSCRIBE_LABEL_DEFAULT_TEXT = 'SUB';
export var RECEIVE_TEXT = 'Receive';
export var RECEIVE_TEXT_LABEL_DEFAULT_TEXT = 'RECEIVE';
export var REQUEST_TEXT = 'Request';
export var REQUEST_LABEL_DEFAULT_TEXT = 'REQUEST';
export var REPLIER_TEXT = 'Reply';
export var REPLIER_LABEL_DEFAULT_TEXT = 'REPLY';
export var REQUIRED_TEXT = 'Required';
export var GENERATED_TEXT = 'Generated';
export var SERVERS_TEXT = 'Servers';
export var OPERATIONS_TEXT = 'Operations';
export var MESSAGES_TEXT = 'Messages';
export var SCHEMAS_TEXT = 'Schemas';
export var CHANNELS_TEXT = 'Channels';
export var PARAMETERS_TEXT = 'Parameters';
export var HEADERS_TEXT = 'Headers';
export var MESSAGE_HEADERS_TEXT = 'Message Headers';
export var HEADERS_EXAMPLE_TEXT = 'Example of headers';
export var TAGS_TEXT = 'Tags';
export var PAYLOAD_TEXT = 'Payload';
export var MESSAGE_PAYLOAD_TEXT = 'Message Payload';
export var PAYLOAD_EXAMPLE_TEXT = 'Example of payload';
export var SCHEMA_EXAMPLE_TEXT = 'Example';
export var SERVER_BINDINGS_TEXT = 'Server Bindings';
export var CHANNEL_BINDINGS_TEXT = 'Channel Bindings';
export var OPERATION_BINDINGS_TEXT = 'Operation Bindings';
export var MESSAGE_BINDINGS_TEXT = 'Message Bindings';
export var BINDINGS_SCHEMA_OBJECT_TEXT = 'Schema Object';
export var NONE_TEXT = 'None';
export var ANY_TEXT = 'Any';
export var ERROR_TEXT = 'Error';
export var EXPAND_ERROR_BUTTON_TEXT = 'Expand';
export var COLLAPSE_ERROR_BUTTON_TEXT = 'Collapse';
export var SECURITY_TEXT = 'Security';
export var URL_VARIABLES_TEXT = 'URL Variables';
export var PLUGINEVENTS = ['plugin:ready', 'plugin:error'];
//# sourceMappingURL=constants.js.map